define([
    'jquery',
    'globals'
], function ($, globals) {
    'use strict';

    const datepicker = require('./vendor/bootstrap-datepicker');
    const calendarBackendUrl = globals.calendarUrl;
    const elSelector = '.calendar';
    let disabledDates;

    const activate = function () {
        console.log('calendar activate');

        $.ajax({
            url: calendarBackendUrl,
            method: "POST",
            data: {
                'service': 'calendar'
            },
            beforeSend: function (request) {
                console.log('start loading calendar backend >>>');
            },
            dataType: 'html'
        })
            .done(function (data, textStatus, jqXHR) {
                disabledDates = data.split(',');

                $(elSelector).map(function (index) {
                    $(this).datepicker({
                        defaultViewDate: {
                            year: (new Date()).getFullYear(),
                            month: (new Date()).getMonth() + index,
                            date: 1
                        },
                        multidate: true,
                        format: 'yyyy-mm-dd',
                        datesDisabled: disabledDates,
                        todayHighlight: true,
                        weekStart: 1,
                        disableTouchKeyboard: true,
                        keyboardNavigation: false,
                        //firstDay: 1,
                        updateViewDate: false
                    });
                });

                // keep month in sync
                const orderMonth = function (e) {
                    var target = e.target;
                    var date = e.date;
                    var calendars = $(elSelector);
                    var positionOfTarget = calendars.index(target);
                    calendars.each(function (index) {
                        if (this === target) {
                            return;
                        }
                        var newDate = new Date(date);
                        newDate.setUTCDate(1);
                        newDate.setMonth(
                            date.getMonth() + index - positionOfTarget
                        );

                        $(this).datepicker('_setDate', newDate, 'view');
                    });
                };

                $(elSelector).on('changeMonth', orderMonth);


                // keep dates in sync
                $(elSelector).on('changeDate', function (e) {
                    let calendars = $(elSelector);
                    let target = e.target;
                    let newDates = $(target).datepicker('getUTCDates');

                    calendars.each(function () {
                        if (this === e.target) {
                            return;
                        }

                        // setUTCDates triggers changeDate event
                        // could easily run into an infinite loop
                        // therefore we check if currentDates equal newDates
                        let currentDates = $(this).datepicker('getUTCDates');

                        if (
                            currentDates &&
                            currentDates.length === newDates.length &&
                            currentDates.every(function (currentDate) {
                                return newDates.some(function (newDate) {
                                    return currentDate.toISOString() === newDate.toISOString();
                                })
                            })
                        ) {
                            return;
                        }

                        $(this).datepicker('setUTCDates', newDates);
                    });
                });
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.error('calendar ajax failed', textStatus);
            })
            .always(function (datajqXHR, textStatus, jqXHRerrorThrown) {
                console.log('<<< calendar loading complete.');
                // $('body').removeClass('loading');
            });
    }
    const deactivate = function () {
        console.log('calendar deactivate');
    }

    return {
        activate: activate,
        deactivate: deactivate
    }
});